export const RNP__LOADING = 'RNP__LOADING';
export const RNP__LOADED = 'RNP__LOADED';
export const RNP__SET_ROLES = 'RNP__SET_ROLES';
export const RNP__SET_PERMISSIONS = 'RNP__SET_PERMISSIONS';
export const RNP__SET_EDIT_PERMISSIONS = 'RNP__SET_EDIT_PERMISSIONS';
export const RNP__SET_INITIAL_ROLES = 'RNP__SET_INITIAL_ROLES';
export const RNP__SET_ACTIVE_ROLES = 'RNP__SET_ACTIVE_ROLES';
export const RNP__SET_FILTER_PERMISSIONS = 'RNP__SET_FILTER_PERMISSIONS';
